import React from 'react';
import PropTypes from 'prop-types'
import { DFPSlotsProvider } from 'react-dfp';
import {DFP_SETUP} from "./ReactDFPHelper";


export const ReactDFPWrapper = (props) => {
    return (
        <DFPSlotsProvider dfpNetworkId={DFP_SETUP.NetworkID} adUnit={props.adUnit} autoLoad={props.autoLoad} collapseEmptyDivs={true}>
            {props.children}
        </DFPSlotsProvider>
    );
};


ReactDFPWrapper.propTypes = {
    adUnit: PropTypes.string.isRequired,
    autoLoad: PropTypes.bool,
    children: PropTypes.any
};

ReactDFPWrapper.defaultProps = {
    autoLoad: true
};



// WEBPACK FOOTER //
// src/client/components/common/adverts/googleDFP/ReactDFPWrapper.js